/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://uly6crf7rbaf5j5vrlv2r6aysi.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2v6aoesakncjrmqrkjmjw6pmdy",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_GwXgffRfR",
    "aws_user_pools_web_client_id": "o71c8kj7r3s3hviqm3hbvcvv8",
    "oauth": {
        "domain": "amtpl-prod.auth.ap-south-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/,https://app.grains.global/,https://auth-prod.grains.global/",
        "redirectSignOut": "http://localhost:3000/,https://app.grains.global/,https://auth-prod.grains.global/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_identity_pool_id": "ap-south-1:298a9cc9-314f-45c1-b417-b767e14fc3e4",
    "aws_user_files_s3_bucket": "amtplfs-devnew-02128f87b9f39-production",
    "aws_user_files_s3_bucket_region": "ap-south-1",
    "API_AMTPL_DATAOPSLAMBDAFUNCTION_NAME": "dataops-production",
    "API_AMTPL_BACKENDOPSLAMBDAFUNCTION_NAME": "backendops-production"
};


export default awsmobile;
